function hasLocaleStorage() {
    try {
        window.localStorage.setItem('checkLocalStorage', 'checkLocalStorage');
        window.localStorage.removeItem('checkLocalStorage');
        return true;
    } catch (err) {
        return false;
    }
}

export { hasLocaleStorage };